// extracted by mini-css-extract-plugin
export default {"registerCard":"Registration_registerCard__3HkrZ"};